module.exports = __webpack_public_path__ + "56b390f1ff5a08b21b0d595a5c6a69dd.jpg";